import { render, staticRenderFns } from "./teaching-detail.vue?vue&type=template&id=4579b50a&scoped=true&"
import script from "./teaching-detail.vue?vue&type=script&lang=js&"
export * from "./teaching-detail.vue?vue&type=script&lang=js&"
import style0 from "./teaching-detail.vue?vue&type=style&index=0&id=4579b50a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4579b50a",
  null
  
)

export default component.exports